import type { JSX } from 'react'

import { IconButton, InfoIcon } from '@buffer-mono/popcorn'

import { ChannelFields } from '~publish/components/Composer/components/ChannelFields'
import { HC_UTM_PARAMS } from '~publish/legacy/utils/contants'

import styles from './ShopGridLinkLabel.module.css'

const SHOP_GRID_HELP_URL = `https://support.buffer.com/articles/instagram-shop-grid-and-grid-preview-sAVyO9orQn?${HC_UTM_PARAMS}`

export function ShopGridLinkLabel(): JSX.Element {
  return (
    <ChannelFields.Label className={styles.label}>
      Shop Grid Link
      <IconButton
        label="Learn more about Shop Grid"
        tooltip="Learn more about Shop Grid"
        as="a"
        size="small"
        variant="tertiary"
        href={SHOP_GRID_HELP_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <InfoIcon color="subtle" />
      </IconButton>
    </ChannelFields.Label>
  )
}
